import React from 'react';
import { Box, ChakraProvider } from '@chakra-ui/react';
import Header from './Header';

import theme from '../../styles/theme';
import '@fontsource/k2d/400.css';
import '@fontsource/k2d/500.css';
import '@fontsource/k2d/700.css';

function Layout({ children, userStatus }) {
  return (
    <ChakraProvider theme={theme}>
      {userStatus === 'signedIn' && <Header />}
      <Box mx='auto' display='flex' justifyContent='center'>
        {children}
      </Box>
    </ChakraProvider>
  );
}

export default Layout;
